"use client";

/**
 * Lift the body's mobile bottom padding so the global Footer clears
 * BOTH the MobileTabBar AND a page-level sticky bottom bar (the
 * /analyze rate-limit row, /calculate submit button, /compare submit
 * button, etc.).
 *
 * The root layout sets `body.pb-20 sm:pb-0` - 80 px of clearance,
 * enough for the 64 px MobileTabBar plus a small breath of margin.
 * When a page mounts an additional fixed bar at
 * `bottom-[calc(env(safe-area-inset-bottom)+4rem)]` (height ~73 px),
 * its top edge sits ~137 px above the screen bottom and overlaps the
 * footer. This component pushes body padding to ~144 px (9 rem) on
 * mobile while mounted, restoring on unmount.
 *
 * Inline-style approach (rather than a CSS variable) keeps the
 * Tailwind `sm:pb-0` rule effective: we only set padding-bottom while
 * the viewport is narrower than the `sm` breakpoint, and clear it
 * otherwise so Tailwind's media query continues to win.
 */
import { useEffect } from "react";

const MOBILE_BREAKPOINT = "(max-width: 639.99px)";
const MOBILE_PB = "9rem";

export default function MobileBottomChromeOffset() {
  useEffect(() => {
    const apply = () => {
      if (window.matchMedia(MOBILE_BREAKPOINT).matches) {
        document.body.style.paddingBottom = MOBILE_PB;
      } else {
        document.body.style.paddingBottom = "";
      }
    };
    apply();
    const mq = window.matchMedia(MOBILE_BREAKPOINT);
    mq.addEventListener("change", apply);
    return () => {
      mq.removeEventListener("change", apply);
      document.body.style.paddingBottom = "";
    };
  }, []);
  return null;
}
